module.exports = __webpack_public_path__ + "static/img/photography-e.c30648f1.png";